import { render } from "./set-password.vue?vue&type=template&id=7d7b8abe&scoped=true"
import script from "./set-password.vue?vue&type=script&lang=js"
export * from "./set-password.vue?vue&type=script&lang=js"

import "./set-password.vue?vue&type=style&index=0&id=7d7b8abe&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7b8abe"]])

export default __exports__